import React from 'react'
import Checkbox from './checkbox'
import clsx from 'clsx'

export default function CheckboxRow<T>(props: {
  checked: boolean
  value: T
  onSelect: (value: T) => void
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={clsx(
        'items-center flex flex-row gap-4 cursor-pointer w-fit rounded-md -m-2 p-2 select-none',
        props.className,
      )}
      onClick={() => props.onSelect(props.value)}
    >
      <Checkbox checked={props.checked} />
      {props.children}
    </div>
  )
}
